import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import vuemask from './plugins/vuemask'
import store from './store'
import './plugins/signature'
import './plugins/hotjar'
import './i18n'

import './directives/clickOutside'

import titleMixin from './mixins/titleMixin'

// global components ------------------------------------
import Pagination from '@/components/app/pagination/Pagination'
Vue.component('h-pagination', Pagination)

import Loading from '@/components/app/Loading'
Vue.component('h-loading', Loading)

import Header from '@/components/app/Header'
Vue.component('h-header', Header)
// ------------------------------------------------------

// global mixins
Vue.mixin(titleMixin)
// ------------------------------------------------------

// global directives
// ------------------------------------------------------

Vue.config.productionTip = false

new Vue({
  router,
  vuetify,
  store,
  vuemask,
  render: (h) => h(App),
}).$mount('#app')
